import { useEffect, useState } from 'react';

const getMobileDetect = (userAgent) => {
  const isAndroid = Boolean(userAgent.match(/Android/i));
  const isIos = Boolean(userAgent.match(/iPhone|iPad|iPod/i));
  const isOpera = Boolean(userAgent.match(/Opera Mini/i));
  const isWindows = Boolean(userAgent.match(/IEMobile/i));
  const isSSR = Boolean(userAgent.match(/SSR/i));
  const isMobileUA = Boolean(isAndroid || isIos || isOpera || isWindows);
  return {
    isMobileUA,
    isSSR,
  };
};

export default function useIsDevice() {
  const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;
  const { isMobileUA, isSSR } = getMobileDetect(userAgent);
  const [isMobile, setIsMobile] = useState(() => {
    if (isSSR) return isMobileUA;
    return isMobileUA || (typeof window !== 'undefined' && window.innerWidth < 900);
  });

  useEffect(() => {
    if (isSSR) return;
    const handleResize = () => {
      setIsMobile(isMobileUA || window.innerWidth < 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobileUA, isSSR]);

  return {
    isMobile,
    isDesktop: !isMobile,
    isMobileUA,
    isSSR,
  };
}
